import { TrustpilotMini } from "staysure-component-library";

import { useWizard } from "@/app/shared-providers/wizard-context-provider";
import RichText from "@/components/atoms/rich-text/rich-text";
import { useDynamicTrustpilotText } from "@/hooks/use-dynamic-trustpilot-text/use-dynamic-trustpilot-text";
import { useWizardTranslation } from "@/libs/i18n/use-wizard-translation";

import Styles from "./cover-type-special-support-section.module.css";
import { useTrustpilotRating } from "./trust-pilot.hook";
import { useCoverTypeContext } from "../../../provider/cover-type.provider";

export default function TrustPilot() {
  const { selectedAnswer, groupedMagnoliaData, magnoliaData } =
    useCoverTypeContext();

  const {
    trustpilotDescription,
    trustpilotSupportCopyText,
    navigateUrl,
    brandDomain,
  } = groupedMagnoliaData[selectedAnswer].descriptionSection;

  const dynamicText = useDynamicTrustpilotText(
    trustpilotDescription,
    brandDomain
  );

  const reviewData = useTrustpilotRating(brandDomain as string) ?? {};

  const { backgroundImageDesktop } = magnoliaData.overlayArea[0];

  const srcImage = `${process.env.NEXT_PUBLIC_MGNL_HOST}/dam/${backgroundImageDesktop?.["@id"]}${backgroundImageDesktop?.["@path"]}`;

  const { current } = useWizard();
  const { t } = useWizardTranslation();

  const showBgImage = current.uiElementControls?.showQuestionDescriptionBgImage;

  const getBgStyles = () => {
    return {
      width: "100%",
      height: "100%",
      backgroundPosition: "center",
      background: `${
        current.uiElementControls?.bgGradient
          ? "linear-gradient(0deg, rgba(0, 0, 0, 0.30) 0%, rgba(0, 0, 0, 0.30) 100%),"
          : ""
      } url(${srcImage}) no-repeat`,
    };
  };

  const ratingLabels = {
    poor: t("trustpilot_rating_poor", "Poor"),
    fair: t("trustpilot_rating_fair", "Fair"),
    good: t("trustpilot_rating_good", "Good"),
    veryGood: t("trustpilot_rating_very_good", "Very Good"),
    excellent: t("trustpilot_rating_excellent", "Excellent"),
  };

  return (
    <div
      data-testid="cover-type-support-content"
      className={` ${
        current.uiElementControls?.bgImgPosition
          ? " lg:!bg-center !bg-bottom"
          : "!bg-bottom"
      } ${
        Styles.trustpilotWrapper
      } rounded-radius-xxl flex lg:flex-col !bg-cover  ${
        showBgImage ? "" : "items-center justify-center"
      } 
                text-surface-neutral-option-2 h-full lg:min-h-[586px] md:min-h-[500px] min-h-[325px]`}
      style={showBgImage ? getBgStyles() : undefined}
    >
      <div
        data-testid="trustpilot-id"
        className="m-spacing-l md:my-[64px] md:mx-spacing-xxxl h-full"
      >
        <TrustpilotMini
          stars={reviewData?.stars ?? 0}
          score={reviewData?.score ?? 0}
          totalReviews={reviewData?.totalReviews ?? ""}
          link={navigateUrl ?? ""}
          ratingLabels={ratingLabels}
          reviewsText={t("trustpilot_review_text", "review(s)")}
        />

        <div
          data-testid="trustpilot-description"
          className="text-surface-neutral-option-1 text-center item-center text-[23px] md:text-[31px] justify-center font-header-font leading-[27.6px] md:leading-[34.1px] mt-spacing-m md:mt-[48px] "
        >
          {dynamicText}
        </div>
        <div
          data-testid="trustpilot-support-copy-section"
          className="justify-items-center text-center"
        >
          <RichText
            richText={trustpilotSupportCopyText ?? ""}
            className={`${Styles.trustpilotSupportRichText} `}
          />
        </div>
      </div>
    </div>
  );
}
